// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__uiYUH","container":"footer_container__zEonK","nav":"footer_nav__yUhkI"};